module.exports = __webpack_public_path__ + "static/skills-0bfbacae26261d898ccfdcb6d936f4db.jpg";